<!--
 * @Author: your name
 * @Date: 2020-11-19 15:21:41
 * @LastEditTime: 2021-04-06 16:40:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /v-intersection/src/view/Home.vue
-->
<template>

  <div class="home F-SC-C ">
    <div class="nav">
      <a href="https://github.com/genjiXYZ/v-intersection" target="_blank">
        <svg t="1605899055123" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2313" width="48" height="48">
          <path d="M402.285714 694.857143q0 22.857143-7.142857 46.857143t-24.571429 43.428571-41.428571 19.428571-41.428571-19.428571-24.571429-43.428571-7.142857-46.857143 7.142857-46.857143 24.571429-43.428571 41.428571-19.428571 41.428571 19.428571 24.571429 43.428571 7.142857 46.857143zm365.714286 0q0 22.857143-7.142857 46.857143t-24.571429 43.428571-41.428571 19.428571-41.428571-19.428571-24.571429-43.428571-7.142857-46.857143 7.142857-46.857143 24.571429-43.428571 41.428571-19.428571 41.428571 19.428571 24.571429 43.428571 7.142857 46.857143zm91.428571 0q0-68.571429-39.428571-116.571429t-106.857143-48q-23.428571 0-111.428571 12-40.571429 6.285714-89.714286 6.285714t-89.714286-6.285714q-86.857143-12-111.428571-12-67.428571 0-106.857143 48t-39.428571 116.571429q0 50.285714 18.285714 87.714286t46.285714 58.857143 69.714286 34.285714 80 16.857143 85.142857 4l96 0q46.857143 0 85.142857-4t80-16.857143 69.714286-34.285714 46.285714-58.857143 18.285714-87.714286zm128-100.571429q0 118.285714-34.857143 189.142857-21.714286 44-60.285714 76t-80.571429 49.142857-97.142857 27.142857-98 12.571429-95.428571 2.571429q-44.571429 0-81.142857-1.714286t-84.285714-7.142857-87.142857-17.142857-78.285714-29.428571-69.142857-46.285714-49.142857-65.714286q-35.428571-70.285714-35.428571-189.142857 0-135.428571 77.714286-226.285714-15.428571-46.857143-15.428571-97.142857 0-66.285714 29.142857-124.571429 61.714286 0 108.571429 22.571429t108 70.571429q84-20 176.571429-20 84.571429 0 160 18.285714 60-46.857143 106.857143-69.142857t108-22.285714q29.142857 58.285714 29.142857 124.571429 0 49.714286-15.428571 96 77.714286 91.428571 77.714286 227.428571z" p-id="2314" fill="#ffffff"></path>
        </svg>
      </a>

      <a href="https://www.npmjs.com/package/v-intersection" target="_blank">
        <svg t="1605899571120" class="icon" viewBox="0 0 1152 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3714" width="48" height="48">
          <path d="M576 576h-64v-128h64v128z m576-256v384H576v64H320v-64H0V320h1152z m-832 64H64v256h128v-192h64v192h64V384z m320 0H384v320h128v-64h128V384z m448 0H704v256h128v-192h64v192h64v-192h64v192h64V384z" p-id="3715" fill="#ffffff"></path>
        </svg>
      </a>
    </div>
    <h1 class="title">v-intersection</h1>
    <Box title="install" :desc="npmDesc" />
    <Box title="vue2.0 import" :desc="importDescjson" />
    <Box title="vue3.0 import" :desc="V3import" />

    <CodeBox title="quick Start" isCodeIcon="true" :code="code.qs.raw" isShow="true" />
    <div class="descBox boxBg ">
      <MD class="markdown-body" />
    </div>
    <CodeBox title="1. try to scroll" desc="when the block is in view, handle your mehtod" isCodeIcon="true" :code="code.demo1.temjs" componentId="demo1" />
    <CodeBox title="2. v-intersection.once" desc="just handle your method once" isCodeIcon="true" :code="code.demo2.temjs" componentId="demo2" />
    <CodeBox title="3. v-intersection.quiet" desc="when binding directive,don't handle your mehtod" isCodeIcon="true" :code="code.demo3.temjs" componentId="demo3" />
    <CodeBox title="4. options:{thresholds:[0,0.01,...0.99,1.00]" desc="set handle step" isCodeIcon="true" :code="code.demo4.temjs" componentId="demo4" />
    <CodeBox title="5. disconnect( )" desc="click btn unobserve" isCodeIcon="true" :code="code.demo5.temjs" componentId="demo5" />
    <CodeBox title="demo6" desc="make a Pagination " isCodeIcon="true" :code="code.demo6.all" componentId="demo6" />

  </div>
</template>

<script>
import MD from "../assets/options.md";
import { effects } from "../plugins/getTem";
import Box from "../components/box";
import CodeBox from "../components/codeBox";

export default {
  components: { Box, CodeBox, MD },
  data() {
    return {
      npmDesc: "npm install v-intersection --save",
      importDesc: `
	  import Vue from "vue"; <br>
	  import intersection from "v-intersection";  <br>
	  Vue.use(intersection) 
    
    `,
      V3import: `
    import intersection from "v-intersection"; <br>
createApp(App).use(intersection ).mount('#app')
    
    `,
      code: effects,
    };
  },
  computed: {
    importDescjson() {
      return this.importDesc;
    },
  },

  mounted() {},
};
</script>

<style lang="scss" >
.nav {
  position: fixed;
  width: 150px;
  top: 48px;
  left: 48px;
  height: 48px;

  display: flex;
  justify-content: space-around;
  align-items: center;
}
.home {
  width: 100%;
  min-height: 200vh;
}
.title {
  color: #ffebcf;
  font-size: 300%;
  margin-top: 100px;
}

.descBox {
  position: relative;
  box-sizing: border-box;
  padding: 10px 30px;
  margin-bottom: 5vh;
  max-width: 70vw;
  min-width: 370px;
}
</style>
